import {
    Flex,
    Container,
    Stack,
    useColorModeValue,
    Heading,
    Text,
    Highlight,
    Divider,
    Badge
} from '@chakra-ui/react'

// import PrimaryButton from '../../../Components/Shared/Buttons/PrimaryButton'
import PrimaryButton from '../../../Components/Elements/PrimaryButton'

import theme from '../../../Config/theme'

import { IoCheckmarkCircleSharp } from "react-icons/io5"

const Plan = ({ name, description, price, priceHighlight, buttonLabel, buttonOnClick, bestValue, features, buttonIsLoading }) => {
    const borderColor = useColorModeValue(theme.borderColor.borderColorLight, theme.borderColor.borderColorDark)
    const backgroundColor = useColorModeValue('gray.100', 'gray.800')

    return (
        <Stack
            border={'1px'}
            borderColor={borderColor}
            borderRadius={'md'}
            p={5}
            bgColor={backgroundColor}
            w={'full'}
            spacing={4}
            style={{ transition: 'transform .2s' }}
            _hover={{ transform: 'scale(1.03)', boxShadow: `5px 5px ${theme.default.defaultColor}` }}
        >
            <Stack direction={'row'} justify={'space-between'} align={'center'}>
                <Text fontWeight={700} fontSize={'2xl'}>{name}</Text>
                {bestValue &&
                    <Text bgColor={theme.default.tertiaryColor} color={'white'} fontWeight={700} fontSize={'sm'} borderRadius={'full'} px={1}>Best Value</Text>
                }
                {/* {bestValue && <Badge bgColor={theme.default.defaultColor} color={'black'} fontSize={'lg'} borderRadius={'full'}>Best Value</Badge>} */}
            </Stack>
            <Text>{description}</Text>
            <Text>
                <Highlight query={priceHighlight} styles={{ fontWeight: 700, fontSize: '3xl', color: theme.default.defaultColor }}>
                    {price}
                </Highlight>
            </Text>

            <Divider borderColor={borderColor} />

            {
                features.map((feature) => (
                    <Stack direction={'row'} align={'center'} fontSize={'lg'} key={feature.feature}>
                        <IoCheckmarkCircleSharp color={feature.limited ? '#D69E2E' : '#38A169'} />
                        <Text>{feature.feature}</Text>
                    </Stack>
                ))
            }

            <PrimaryButton label={buttonLabel} onClick={buttonOnClick} isLoading={buttonIsLoading} />
        </Stack>
    )
}

export default Plan